
import { AssetTypeMetadataBase } from './asset-type.metadata.base';


export class AssetTypeMetadata extends AssetTypeMetadataBase {
  constructor() {
    super();
  }
}

export const ASSET_TYPE_METADATA: AssetTypeMetadata = new AssetTypeMetadata();


